import {jwtDecode} from "jwt-decode";

const AuthService = {
    isAuthenticated: () => {
        const authToken = localStorage.getItem("token");
        if (!authToken) {
            return false;
        }
        try {
            const { exp } = jwtDecode(authToken);
            const currentTime = Math.floor(Date.now() / 1000);
            if (exp <= currentTime) {
                localStorage.removeItem("token");
                return false;
            }
            return true;
        } catch (err) {
            console.error("Error decoding token:", err);
            localStorage.removeItem("token");
            return false;
        }
    },
    isAdmin: () => {
        const authToken = localStorage.getItem("token");
        if (!authToken) {
            return false;
        }
        try {
            const data = jwtDecode(authToken);
            if(data?.user?.role === "admin" || data?.user?.role === 'superAdmin'){
                return true
            }else{
                return false
            }
        } catch (err) {
            console.error("Error decoding token:", err);
            return false;
        }
    },
    isSuperAdmin: () => {
        const authToken = localStorage.getItem("token");
        if (!authToken) {
            return false;
        }
        try {
            const data = jwtDecode(authToken);
            return data?.user?.role === "superAdmin";
        } catch (err) {
            console.error("Error decoding token:", err);
            return false;
        }
    },
    logout: (navigate) => {
        localStorage.removeItem("token");
        if (navigate) navigate("/login");
    },
};

export default AuthService;
